export default __webpack_public_path__ + "static/media/DSC.606938bd.webp";